module.exports = __webpack_public_path__ + "img/hrm-jordan-sm.2c5520e.png";